var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.592 0a2.143 2.143 0 00-2.146 2.143v9.135h1.83V2.143a.31.31 0 01.31-.309h.57V0h-.564zM25 11.592a2.141 2.141 0 00-2.143-2.142H13.72v1.828h9.137a.31.31 0 01.31.31v.57h1.834v-.566zM13.408 0a2.143 2.143 0 012.143 2.143V8.77H13.72V2.143a.31.31 0 00-.31-.309h-.57V0h.568zM25 13.411a2.143 2.143 0 01-2.143 2.144h-6.626V13.72h6.626a.31.31 0 00.31-.31v-.569H25v.57zM0 13.411a2.143 2.143 0 002.142 2.144h9.138V13.72H2.142a.31.31 0 01-.309-.31v-.569H0v.57zM0 11.592A2.141 2.141 0 012.142 9.45h6.626v1.828H2.142a.31.31 0 00-.309.31v.57H0v-.566zM13.408 25a2.142 2.142 0 002.143-2.142v-9.137H13.72v9.137a.31.31 0 01-.31.31h-.57V25h.568zM11.592 25a2.144 2.144 0 01-2.146-2.142v-6.626h1.83v6.626a.31.31 0 00.31.31h.57V25h-.564z",
    fill: "#7F9FE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/miniLogo.dae883e25c199ba9d25c56337b6b2c4f.svg";
export { ForwardRef as ReactComponent };